import type { APIRequest, APIResponsePromise } from '@/_types/api';
import { _callBackend } from '@/_api/api';
import type { EntitiesV2FilterObject } from '@/_types/entities';
import type { Company } from '@/_types/models/company';

export const getAdminEntities = async ({
  assigned_advisor_id,
  auto_export_enabled,
  count,
  descending,
  entity_type,
  hide_actives,
  hide_inactives,
  firm_role_id,
  firm_role_user_id,
  only_ids,
  page,
  rows_per_page,
  search_term,
  selected_entity_tags_filter: selected_entity_tags_filter_from_attrs,
  sort_by,
  show_only_deleted,
  token,
}: APIRequest<EntitiesV2FilterObject>): APIResponsePromise<
  Array<Company> & { count: number; ids: number[] }
> => {
  const adjustedPage: number = (page ?? 0) + 1;

  const selected_entity_tags_filter: string =
    selected_entity_tags_filter_from_attrs &&
    selected_entity_tags_filter_from_attrs?.length > 0
      ? '&' +
        selected_entity_tags_filter_from_attrs
          ?.map(
            (tag) => `selected_entity_tags_filter[]=${encodeURIComponent(tag)}`,
          )
          .join('&')
      : '';
  // prettier-ignore
  return await _callBackend(
    `/v2/entities?page=${adjustedPage
    }&rows_per_page=${rows_per_page
    }&sort_by=${sort_by
    }&descending=${descending
    }&search_term=${encodeURIComponent(search_term)
    }&assigned_advisor_id=${assigned_advisor_id
    }&firm_role_id=${firm_role_id
    }&firm_role_user_id=${firm_role_user_id
    }&entity_type=${entity_type
    }&hide_inactives=${hide_inactives
    }&hide_actives=${hide_actives
    }&show_only_deleted=${show_only_deleted
    }${auto_export_enabled !== undefined ? `&auto_export_enabled=${auto_export_enabled}` : ''
    }${count ? '&count=true' : ''
    }${only_ids ? '&only_ids=true' : ''
    }${selected_entity_tags_filter}`
    ,
    'GET',
    null,
    token,
  );
};

export const getAdminEntitiesByIds = async ({
  token,
  ids,
}: {
  token: string;
  ids: number[];
}): APIResponsePromise<Array<Company>> => {
  return await _callBackend(
    `/v2/entities/by_ids?${ids.map((id) => `ids[]=${id}`).join('&')}`,
    'GET',
    null,
    token,
  );
};

export const restoreDeletedEntity = async ({
  entity_id,
  token,
}: {
  entity_id: number;
  token: string;
}): APIResponsePromise<{ success: boolean }> => {
  return await _callBackend(
    `/v2/entities/${entity_id}/restore_deleted_entity`,
    'POST',
    null,
    token,
  );
};

export const getRelatedEntities = async ({
  entityId,
  token,
}: {
  entityId: number;
  token: string;
}): APIResponsePromise<Array<Company>> => {
  return await _callBackend(
    `/v2/entities/${entityId}/get_related_entities`,
    'GET',
    null,
    token,
  );
};
